import * as React from 'react'
import { useState, useEffect } from 'react'
import { Button, CardBody } from 'reactstrap'

const { I18n } = window as any

interface TwoFactorBackupCodesViewProps {
  backupCodes: string[]
}

function TwoFactorBackupCodesView({ backupCodes }: TwoFactorBackupCodesViewProps): JSX.Element {
  const [copied, setCopied] = useState(false)
  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => setCopied(false), 2000)
      return () => clearTimeout(timer)
    }
  }, [copied])
  const handleCopyToClipboard = () => {
    const codesText = backupCodes.join('\n')
    navigator.clipboard.writeText(codesText).then(() => {
      setCopied(true)
    })
  }

  return (
    <CardBody>
      <h4>{I18n.t('users.two_factor.backup_codes_title')}</h4>
      <p>{I18n.t('users.two_factor.backup_codes_info')}</p>

      <pre className="backup-codes-list">
        <code>{backupCodes.join('\n')}</code>
      </pre>

      <div className="mt-4">
        <Button color="secondary" onClick={handleCopyToClipboard} className="mr-2">
          {copied && <i className="fa fa-check mr-1" />}
          {!copied && <i className="fa fa-clipboard mr-1" />}
          {I18n.t('users.two_factor.copy_to_clipboard')}
        </Button>
      </div>
    </CardBody>
  )
}

export default TwoFactorBackupCodesView
